module.exports = __webpack_public_path__ + "img/20Y30G.a7497299.png";